import { Link } from 'react-router-dom';
import { FaTasks, FaQuran, FaChartBar, FaMosque, FaPalette } from 'react-icons/fa';
import Logo from '../components/common/Logo';

const features = [
    {
        id: 'tasks',
        icon: <FaTasks />,
        title: 'Gestion des Tâches',
        description: 'Organisez vos objectifs quotidiens avec des catégories personnalisées, des priorités et un suivi visuel. Cochez vos tâches et célébrez chaque accomplissement.',
        image: '/screenshots/PageTasks.png',
    },
    {
        id: 'daily',
        icon: <FaMosque />,
        title: 'Dîne au Quotidien',
        description: 'Suivez vos 5 actions spirituelles essentielles : Prière, Tasbih, Récitation, Douaa et Sadaqa. Une barre de progression vous accompagne vers la constance.',
        image: '/screenshots/DineQuotidien.png',
    },
    {
        id: 'quran',
        icon: <FaQuran />,
        title: 'Tracker Coran',
        description: 'Lisez et écoutez le Coran avec traduction. Marquez vos pages, suivez votre progression et atteignez vos objectifs de lecture quotidiens.',
        image: '/screenshots/PageCoran.png',
    },
    {
        id: 'stats',
        icon: <FaChartBar />,
        title: 'Statistiques',
        description: "Visualisez votre progression sur 30 jours avec des graphiques détaillés. Tâches, actions quotidiennes et lecture du Coran en un coup d'œil.",
        image: '/screenshots/PageStats.png',
    },
];

const LandingPage = () => {
    return (
        <div className="landing-page">
            {/* Header */}
            <header className="landing-header">
                <div className="landing-header-inner">
                    <Logo size="default" showText={false} variant="auth" />
                    <Link to="/login" className="btn btn-primary landing-login-btn">
                        Se connecter
                    </Link>
                </div>
            </header>

            {/* Hero */}
            <section className="landing-hero">
                <div className="landing-hero-content">
                    <Logo size="large" showText={false} variant="auth" />
                    <h1 className="landing-hero-title">
                        daily<span>Deen</span>
                    </h1>
                    <p className="landing-hero-subtitle">
                        Votre compagnon de productivité spirituelle
                    </p>
                    <p className="landing-hero-desc">
                        Gérez vos tâches, suivez vos actions quotidiennes, lisez le Coran et visualisez votre progression — tout en un seul endroit.
                    </p>
                    <Link to="/login" className="btn btn-primary landing-hero-cta">
                        Commencer maintenant
                    </Link>
                </div>
            </section>

            {/* Features */}
            <section className="landing-features">
                {features.map((feature, index) => (
                    <div
                        key={feature.id}
                        className={`landing-feature ${index % 2 !== 0 ? 'reverse' : ''}`}
                    >
                        <div className="landing-feature-image">
                            <img
                                src={feature.image}
                                alt={feature.title}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.parentNode.classList.add('placeholder');
                                }}
                            />
                        </div>
                        <div className="landing-feature-text">
                            <div className="landing-feature-icon">{feature.icon}</div>
                            <h2>{feature.title}</h2>
                            <p>{feature.description}</p>
                        </div>
                    </div>
                ))}
            </section>

            {/* Themes */}
            <section className="landing-themes">
                <div className="landing-themes-header">
                    <div className="landing-feature-icon"><FaPalette /></div>
                    <h2>3 Thèmes au choix</h2>
                    <p>Personnalisez votre expérience avec le thème qui vous correspond. Chaque thème adapte les couleurs de toute l'application.</p>
                </div>
                <div className="landing-themes-grid">
                    {[
                        { name: 'Défaut', label: 'Vert & Doré', image: '/screenshots/themeDefault.png' },
                        { name: 'Girly', label: 'Rose & Corail', image: '/screenshots/themeGirly.png' },
                        { name: 'Neutre', label: 'Ardoise & Gris', image: '/screenshots/themeNeutre.png' },
                    ].map((t) => (
                        <div key={t.name} className="landing-theme-card">
                            <div className="landing-theme-image">
                                <img
                                    src={t.image}
                                    alt={`Thème ${t.name}`}
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.parentNode.classList.add('placeholder');
                                    }}
                                />
                            </div>
                            <h3>{t.name}</h3>
                            <span>{t.label}</span>
                        </div>
                    ))}
                </div>
            </section>

            {/* Footer */}
            <footer className="landing-footer">
                <p>by <strong>OumanourCreations</strong></p>
            </footer>
        </div>
    );
};

export default LandingPage;
